import './Messages.css'

function Message({title, body, classNames = '', buttonText = '', buttonOnClick = false}) {
    return <div className={'tda-Message' + (classNames !== '' ? ` ${classNames}` : '')}>
        <div className="tda-MessageTitle">{title}</div>
        <div className="tda-MessageBody">{body}</div>
        {buttonOnClick ? <center><button onClick={buttonOnClick}>{buttonText}</button></center> : false}
    </div>
}

function ErrorMessage({title, body, buttonText = '', buttonOnClick = false}) {
    return <Message title={title} body={body} classNames='tda-Message-Error' buttonText={buttonText} buttonOnClick={buttonOnClick} />
}
function WarningMessage({title, body, buttonText = '', buttonOnClick = false}) {
    return <Message title={title} body={body} classNames='tda-Message-Warning' buttonText={buttonText} buttonOnClick={buttonOnClick} />
}
function SuccessMessage({title, body, buttonText = '', buttonOnClick = false}) {
    return <Message title={title} body={body} classNames='tda-Message-Success' buttonText={buttonText} buttonOnClick={buttonOnClick} />
}

export { Message, ErrorMessage, WarningMessage, SuccessMessage }